<template>
  <div id="TemplateTableComponent">
    <v-snackbar
      v-model="snackbar.show"
      :timeout="4000"
      top
      :color="snackbar.color"
    >
      <span>{{ snackbar.text }}</span>
      <v-btn
        color="white"
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-card class="p-4">
      <v-spacer />
      <v-card-title>
        <v-text-field
          v-model="search"
          class="mb-4"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          filled
          rounded
        />
      </v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="selectedIndustries"
          label="Filter by industries"
          class="textField"
          :items="industries"
          item-text="name"
          item-value="id"
          deletable-chips
          multiple
          outlined
          chips
          return-object
        />
        <v-data-table
          v-model="selected"
          :headers="formTable.headers"
          :items="rows"
          item-key="name"
          sort-by="updated_at_unix"
          sort-desc
          :loading="loading"
          :search="search"
          :options.sync="tableOptions"
          @update:items-per-page="saveLocalItemsPerPage($event)"
        >
          <template v-slot:no-data>
            <div class="my-4">
              <p>No templates found</p>
            </div>
          </template>
          <template v-slot:loading>
            <div class="my-4">
              <p>Loading templates...</p>
            </div>
          </template>
          <template v-slot:[`item.name`]="{ item }">
            {{ item.name }}
          </template>

          <template v-slot:[`item.updated_at_unix`]="{ item }">
            {{ item.updated_at }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              v-if="!is_admin"
              title="create form"
              color="green"
              class="white--text"
              fab
              small
              depressed
              :to="{ name: 'forms.create', params: { templateId: item.id } }"
            >
              <v-icon>mdi-plus-circle</v-icon>
            </v-btn>
            <v-btn
              v-if="is_admin"
              title="edit"
              color="agency-color-primary"
              class="white--text"
              fab
              small
              depressed
              :to="{ name: 'templates.edit', params: { id: item.id } }"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              v-if="is_admin"
              title="copy"
              color="agency-color-primary"
              class="white--text"
              fab
              small
              depressed
              @click="copy(item)"
            >
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
            <v-btn
              title="preview"
              color="agency-color-primary"
              class="white--text"
              fab
              small
              depressed
              :to="{ name: 'templates.preview', params: { id: item.id } }"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>

            <v-btn
              v-if="is_admin"
              title="delete"
              color="red"
              class="white--text"
              fab
              small
              depressed
              @click="prompt(item, 'delete')"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="actionDialog"
      max-width="350"
      attach
    >
      <v-card
        :loading="actionDialogLoading"
        :disabled="actionDialogLoading"
      >
        <v-card-title class="headline">
          Are you sure?
        </v-card-title>
        <v-card-text>
          <small>
            <b>{{ actionItem.additional_info }}</b>
          </small>
          <br>
          Are you sure you want to {{ action }} {{ actionItem.name }}?
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red"
            text
            @click="actionDialog = false"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            color="green"
            text
            @click="confirm()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="templateDialog"
      max-width="500"
      attach
    >
      <v-card>
        <v-card-title class="headline">
          {{ templateData.title }}
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-if="templateData.editMode"
                  v-model="templateData.name"
                  :rules="[...Rules.required]"
                  label="Name"
                  placeholder="Template Name"
                />
                <span v-else>
                  <strong>Name:</strong> {{ templateData.name }}
                </span>
              </v-col>
              <v-col>
                <v-autocomplete
                  v-model="templateData.industries"
                  label="Select template industries"
                  class="textField"
                  :items="industries"
                  :readonly="!templateData.editMode"
                  item-text="name"
                  item-value="id"
                  deletable-chips
                  multiple
                  outlined
                  chips
                  return-object
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red"
            text
            @click="templateDialog = false"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            v-if="templateData.editMode"
            color="green"
            text
            outlined
            @click="updateTemplate()"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'FormTableComponent',
  props: {
    //
  },
  data: () => ({
    selected: [],
    loading: true,
    search: '',
    selectedIndustries: [],
    formTable: {
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Last Updated',
          value: 'updated_at_unix'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'end',
          sortable: false
        }
      ],
      items: []
    },
    action: '',
    actionDialog: false,
    templateDialog: false,
    actionItem: {},
    actionDialogLoading: false,
    industries: [],
    templateData: {
      title: '',
      editMode: false,
      id: '',
      name: '',
      industries: []
    },
    snackbar: {
      show: false,
      text: '',
      color: 'white'
    }
  }),
  computed: {
    is_admin () {
      return this.$store.state.users.user.is_admin
    },
    rows () {
      if (!this.formTable.items.length) {
        return []
      }
      return this.formTable.items.filter(item => {
        const selectedIds = this.selectedIndustries.map(x => x.id)
        if (selectedIds.length === 0) {
          return true
        }
        const itemIndystriesIds = item.industries.map(y => y.id)
        for (var key in selectedIds) {
          if (itemIndystriesIds.includes(selectedIds[key])) {
            return true
          }
        }
        return false
      })
    }
  },
  created () {
    this.load()
  },
  methods: {
    prompt (item, action) {
      this.actionDialog = true
      this.action = action
      this.actionItem = item
      this.actionItem.name = item.name
      if (action === 'delete') {
        this.actionItem.additional_info =
        'Warning: Deleting this form will also delete all related form data'
      }
    },
    confirm () {
      switch (this.action) {
        case 'delete':
          this.deleteTemplate()
          break
        default:
          break
      }
    },
    copy (item) {
      const self = this // Vue instance
      self.loading = true

      self.$store.dispatch('templates/copyTemplate', { id: item.id }).then(
        response => {
          self.$router.push({ name: 'templates.edit', params: { id: response.data.id } })
        },
        error => {
          self.loading = false
          alert('There was an error copying your form.')
          self.$emit('error', error)
        })
    },
    load () {
      const self = this
      self.LoadStateDependencies(['templates.templates']).then(() => {
        self.formTable.items = self.$store.state.templates.templates
        self.loading = false
      })
      axios.get(self.URLs.core.industries.root).then(
        response => {
          self.industries = response.data.data
        }
      )
    },
    deleteTemplate () {
      const self = this
      self.actionDialogLoading = true
      self.loading = true
      self.$store
        .dispatch('templates/deleteTemplate', self.actionItem)
        .then(response => {
          self.snackbar.text = response.data.message
          self.snackbar.color = 'green'
          self.snackbar.show = true
          self.templateDialog = false
          self.loading = false
          self.actionItem = {}
          self.actionDialog = false
          self.actionDialogLoading = false
        })
        .then(() => {
          this.load()
        })
    },
    showTemplate (item, action) {
      const self = this
      self.templateData.title = 'Template'
      self.templateData.editMode = false
      self.templateDialog = true
      self.templateData.id = item.id
      self.templateData.name = item.name
      self.templateData.industries = item.industries
      if (action === 'edit') {
        self.templateData.title = 'Edit Template'
        self.templateData.editMode = true
      }
    },
    updateTemplate () {
      const self = this
      self.Loading = true
      self.$store
        .dispatch('templates/updateTemplate', self.templateData)
        .then(
          response => {
            self.snackbar.text = 'Template has been successfully updated!'
            self.snackbar.color = 'green'
            self.snackbar.show = true
            self.templateDialog = false
            self.loading = false
            self.formTable.items = self.$store.state.templates.templates
            self.actionItem = {}
          },
          error => {
            self.snackbar.text = error.response.data.errors.message
            self.snackbar.color = 'red'
            self.snackbar.show = true
            self.loading = false
          }
        )
    }
  }
}
</script>
